import { Link, List, ListItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { getLegalInfos } from '../constants';

interface ILegalItem {
  href: string;
  id: string;
  label: string;
}

export const LegalMenu: React.FC = (): JSX.Element => {
  const { i18n, t } = useTranslation();

  const legalList: ILegalItem[] = getLegalInfos(i18n.language);

  return (
    <List display="flex" flexWrap="wrap" justifyContent={{ base: 'space-between', md: 'initial' }}>
      {legalList.map((item) => (
        <ListItem _last={{ mr: 0 }} key={`menuItem-${item.id}`} mr={{ base: 0, sm: 12 }}>
          <Link fontSize="medium" href={item.href} target="_blank">
            {t(item.label)}
          </Link>
        </ListItem>
      ))}
    </List>
  );
};
